import { selectIsAccountManager, selectIsAdmin, selectIsClient, selectIsMechanic, selectIsOwner, selectIsPmfSupport, selectIsSupervisor, selectIsVendor } from "features/user/userSlice";
import { modes } from './modes';
import { roles } from "./roles";
import { useAuth } from "react-oidc-context";
import store from "app/store/store";


export const hasPermission = (permission) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const auth = useAuth();
    const isPmfSupport = auth.user?.profile?.role === "pmf_support";
    const permissions = auth.user?.profile?.permission || [];

    return isPmfSupport || permissions.includes(permission);
};

export const isAuthorized = (profile) => {
    //We need to explicitely take the current state from the store since this is called outside of React rendering
    let state = store.getState();
    const isPmfSupport = selectIsPmfSupport(state);
    const isOwner = selectIsOwner(state);
    const isClient = selectIsClient(state);
    const isAdmin = selectIsAdmin(state);
    const isAccountManager = selectIsAccountManager(state);
    const isMechanic = selectIsMechanic(state);
    const isSupervisor = selectIsSupervisor(state);
    const isVendor = selectIsVendor(state);

    const hasRole = (role) => {
        const roleChecker = {
            [roles.PMF_SUPPORT]: isPmfSupport,
            [roles.OWNER]: isOwner,
            [roles.ADMIN]: isAdmin,
            [roles.CLIENT]: isClient,
            [roles.ACCOUNT_MANAGER]: isAccountManager,
            [roles.MECHANIC]: isMechanic,
            [roles.SUPERVISOR]: isSupervisor,
            [roles.VENDOR]: isVendor,
        };
        return roleChecker[role] || false;
    };

    const checkProfile = (profileMode) => {
        return profileMode?.some(item =>
            typeof item === 'string' ? hasRole(item) : hasPermission(item.key)
        );
    };

    return isPmfSupport || checkProfile(profile?.[modes.READONLY]) || checkProfile(profile?.[modes.EDIT]) || checkProfile(profile?.[modes.EDIT_PERMISSION]);
};